<div
  class="h-400 min-h-400 max-h-400 border-2 border-dashed border-gray-300 rounded-2xl"
>
  <div class="box">
    <i (click)="mainRoute()" class="dx-icon-back dx-icon-custom-style pointer">
    </i>
    <h5 class="p-3">CONTROLS</h5>
  </div>


  <div class="p-3">
    <h5>teb Gider</h5>
    <div class="grid-3">
      <dk-ctl-gen-kontrol [labelText]="'teb gider'" [controlName]="'TebGider'"></dk-ctl-gen-kontrol>
    </div>
    <h5>Sas Abone Kişi</h5>
    <div class="grid-3">
      <dk-ctl-sas-abone-kisi [labelText]="'Abone Kişi'"></dk-ctl-sas-abone-kisi>
    </div>
    <h5>IKA PERSONEL</h5>
    <div class="grid-3">
      <dk-ctl-ika-personel [isActiveDate]="'2020-12-30'" [labelText]="'IKA Personel'"></dk-ctl-ika-personel>
    </div>
  </div>
  <div class="p-3">
    <h5>GENEL KONTROL</h5>
    <div class="grid-3">
      <div class="p-3">
        <h5>filterColumn Uygulanan TmsTasinir</h5>
        <dk-ctl-gen-kontrol [labelText]="'Tms Taşınır'" [code]="'1500101'" [filterColumn]="'TasinirKod'" [controlName]="'TmsTasinir'"></dk-ctl-gen-kontrol>
        <dk-ctl-gen-kontrol [labelText]="'Tms Taşınır'" [filterColumn]="'TasinirKod'" [controlName]="'TmsTasinir'"></dk-ctl-gen-kontrol>
      </div>
      <div class="p-3">
        <h5>filterColumn Uygulanmayan TmsTasinir</h5>
        <dk-ctl-gen-kontrol [labelText]="'Tms Taşınır'" [controlName]="'TmsTasinir'"></dk-ctl-gen-kontrol>
      </div>
    </div>

    <div class="grid-3">
      <dx-text-box [(value)]="controlName2" [showClearButton]="true"
          placeholder="Tablo Adı" (onValueChanged)="onValueChangeTable2($event)">
      </dx-text-box>
      <dk-ctl-teb-donem (dataResult)="onValueChangeTablePeriod2($event)" [labelText]="'Kntrl Dönem'"></dk-ctl-teb-donem>
      <dk-ctl-gen-kontrol [controlName]="controlName2" [period]="selectedControlPeriod"></dk-ctl-gen-kontrol>
    </div>
  </div>


  <div class="p-3">
    <h5>BİRİM TÜRÜ TREE VİEW</h5>
    <div class="grid-3">
        <dk-ctl-birim-tur-tree></dk-ctl-birim-tur-tree>
    </div>

  </div>

  <div class="p-3">
    <h5>TMS</h5>

    <div class="grid-2">
      <dk-ctl-gen-kontrol (dataResult)="getTmsTasinir($event)" [controlName]="'TmsTasinir'"></dk-ctl-gen-kontrol>
      <dk-ctl-gen-kontrol (dataResult)="getTmsDemirbasYer($event)" [controlName]="'TmsDemirbasYer'" [type]="'number'" [labelText]="'Tms Demirbaş Yer'"></dk-ctl-gen-kontrol>
      <dk-ctl-tms-ambar [labelText]="'Tms Ambar'"></dk-ctl-tms-ambar>
      <dk-ctl-tms-ambar-blok (dataResult)="getTmsAmbarBlok($event)" [ambarCode]="101" [labelText]="'Tms Ambar Blok'"></dk-ctl-tms-ambar-blok>
      <dk-ctl-tms-ambar-bolum [blokCode]="blokCode" [labelText]="'Tms Ambar Bolum'"></dk-ctl-tms-ambar-bolum>
      <dk-ctl-tms-ambar-raf [bolumCode]="" [labelText]="'Tms Ambar Raf'"></dk-ctl-tms-ambar-raf>
      <dk-ctl-tms-cikis-yer [belediyeCode]="3514" [labelText]="'Tms Çıkış Yeri'"></dk-ctl-tms-cikis-yer>
      <dk-ctl-gen-mahalle-cadde-sokak [labelText]="'Mah. Cad./Sk.'"></dk-ctl-gen-mahalle-cadde-sokak>
      <dk-ctl-tms-demirbas [labelText]="'Sicil Kodu'"></dk-ctl-tms-demirbas>
      <dk-ctl-tms-tasinir-giris-bakiye [donem]="2020" [inputArea]="false" (dataResult)="setDataresult($event)"></dk-ctl-tms-tasinir-giris-bakiye>
    {{mutlipleSelectResult| json}}
    </div>
  </div>

  <div class="p-3">
    <h5>GEN</h5>
    <div class="grid-3">
      <dk-ctl-gen-kisi [labelText]="'Gen Kişi'" [columnName]="'Tckn'" [filterColumn]="'Tckn'"></dk-ctl-gen-kisi>
      <dk-ctl-gen-kisi [labelText]="'Gen Kişi ExBirlesenEh'" [exBirlesenEh]="true"></dk-ctl-gen-kisi>
      <dk-ctl-gen-kisi-gelir [labelText]="'Gen Kişi Gelir'" [code]="17831415028"></dk-ctl-gen-kisi-gelir>
      <dk-ctl-gen-kullanici [labelText]="'Gen Kullanıcı'"></dk-ctl-gen-kullanici>
    </div>
  </div>

  <div class="p-3">
    <h5 class="">TEB DÖNEM SEÇİMİ</h5>
    <div class="grid-3">
      <dk-ctl-teb-donem (dataResult)="getTebPeriod($event)" [labelText]="'Dönem'"></dk-ctl-teb-donem>
    </div>
  </div>

  <div class="p-3">
    <h5>TEB</h5>
    <div class="grid-3">
      <dk-ctl-teb-finansman [period]="tebSeciliDonem" [labelText]="'Finansman'"></dk-ctl-teb-finansman>
      <dk-ctl-teb-fonksiyon [period]="tebSeciliDonem" [labelText]="'Fonksiyon'"></dk-ctl-teb-fonksiyon>
      <dk-ctl-teb-gelir [period]="tebSeciliDonem" [labelText]="'Gelir'"></dk-ctl-teb-gelir>
      <dk-ctl-teb-gider [period]="tebSeciliDonem" [labelText]="'Gider'"></dk-ctl-teb-gider>
      <dk-ctl-teb-kurum-sinif [period]="tebSeciliDonem" [labelText]="'Kurum Sınıf'"></dk-ctl-teb-kurum-sinif>
    </div>
  </div>

  <div class="p-3">
    <h5>TEB EKONOMİK</h5>
    <div class="grid-3">
      <div class="dx-field">
        <div class="dx-field-label">Hesap Türü Seçimi</div>
        <div class="dx-field-value">
          <dx-radio-group
            [items]="priorities"
            layout="vertical"
            (valueChange)="piHesapTuruSelect($event)"
          >
          </dx-radio-group>
        </div>
      </div>
      <div class="dx-field">
        <div class="dx-field-label">Harcama Kodu Seçimi</div>
        <div class="dx-field-value">
          <dx-radio-group
            [items]="priorities"
            layout="vertical"
            (valueChange)="piHarcamaKoduSelect($event)"
          >
          </dx-radio-group>
        </div>
      </div>
      <dk-ctl-teb-ekonomik [labelText]="piHesapTuru===1?'Gelir':piHesapTuru===2 && harcamaKodu===null?'Gider':''" [period]="2023" [piHesapTuru]="piHesapTuru" [harcamaKodu]="harcamaKodu"></dk-ctl-teb-ekonomik>
    </div>
  </div>


  <div class="p-3">
    <h5 class="">TEM DÖNEM SEÇİMİ</h5>
    <div class="grid-3">
      <dk-ctl-tem-donem  labelText="Dönem" [isReadOnly]="false"  (dataResult)="getTemPeriod($event)"></dk-ctl-tem-donem>
    </div>
  </div>

  <div class="p-3">
    <h5>TEM</h5>
    <div class="grid-3">
      <dk-ctl-tem-defter-tur [labelText]="'Defter Tür'"></dk-ctl-tem-defter-tur>
      <dk-ctl-tem-hesap [isMainAccount]="true" [period]="temSeciliDonem" [labelText]="'Hesap'"></dk-ctl-tem-hesap>
      <dk-ctl-tem-imza-yetki [period]="temSeciliDonem" [labelText]="'İmza Yetki'"></dk-ctl-tem-imza-yetki>
      <dk-ctl-tem-harcama [period]="temSeciliDonem" [labelText]="'Harcama'"></dk-ctl-tem-harcama>
      <dk-ctl-tem-taahhut [period]="temSeciliDonem" [labelText]="'Taahhüt'"></dk-ctl-tem-taahhut>
      <dk-ctl-tem-defter
        [period]="temSeciliDonem"
        accountCode="3200203"
        [receiptDate]="controlDate"
        [labelText]="'Defter'"
      ></dk-ctl-tem-defter>
    </div>
  </div>

  <div class="p-3">
    <h5>IKA PERSONEL</h5>
    <div class="grid-3">
      <dk-ctl-gys-tahsil-ana [belediyeCode]="3514" [labelText]="'Makbuz Kodu'"></dk-ctl-gys-tahsil-ana>
    </div>
  </div>



</div>
